import {AfterContentInit, Component, OnDestroy} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { ServiceType } from 'app/core/service-type.model';
import { IInputFile } from 'app/files/file.model';
import { WizardUploadComponent } from 'app/orders/wizard/upload/upload.component';
import { WizardService } from 'app/orders/wizard/wizard.service';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { UILensService } from 'app/ui/lens/lens.service';
import { AccountService } from 'app/user/account.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { WelcomeCaptureComponent } from 'app/welcome/capture/capture.component';
import { filter, first } from 'rxjs/operators';
import { ApplicationsService } from '../applications/applications.service';


@Component({
  selector: 'documents',
  templateUrl: 'documents.component.html',
  styleUrls: ['documents.component.scss']
})
export class DocumentsComponent implements AfterContentInit, OnDestroy {
  ServiceType = ServiceType;

  get allowDataCapture(): boolean {
    return this._accountService.account.allowDataCapture;
  }

  get serviceType(): ServiceType {
    return this._router.url.indexOf('documents') === -1
      ? ServiceType.InvoiceCapture
      : ServiceType.DocumentCapture;
  }

  verificationUrl: string = '/verification';

  constructor(
    private _accountService: AccountService,
    private _applicationsService: ApplicationsService,
    private _dialogService: UIDialogService,
    private _router: Router,
    private _userSettingsService: UserSettingsService,
    private _wizardService: WizardService,
    private _uiLensService: UILensService
  ) {
    this._userSettingsService.serviceType = this._router.url.indexOf('documents') === -1
      ? ServiceType.InvoiceCapture
      : ServiceType.DocumentCapture;
  }

  ngOnDestroy() {
    this._userSettingsService.showBackground = false;
  }

  ngAfterContentInit(): void {
    if (
      !this._userSettingsService.welcomeTraining &&
      this._userSettingsService.visibleInvoicesUploadArea
    ) {
      this._router.events
        .pipe(
          filter(event => event instanceof NavigationEnd),
          first()
        )
        .subscribe(() => {
          this._uiLensService.open(WelcomeCaptureComponent, 'capture');
        });
    }
  }

  uploadFiles = (files: IInputFile[]) => {
    const isDemoApplication = !this._applicationsService.defaultApplication().isCustomized;
    const isDocumentCapture = this.serviceType === ServiceType.DocumentCapture;

    if (isDemoApplication && isDocumentCapture) {
      return
    }

    if (files && files.length) {
      this._wizardService.upload(files);
      this.openWizard();
    }
  };

  openWizard = (): void => {
    this._dialogService.open(WizardUploadComponent, {
      data: {
        skipCreateDialog:
          this._userSettingsService.rememberImportSettings,
        showSettings:
          this._userSettingsService.rememberImportSettings
      }
    });
  };
}
